module.exports = __webpack_public_path__ + "static/media/objectplayer.3b01550d.png";